module.exports = __webpack_public_path__ + "images/emoji/rice_ball.8446a9d5dde8176670e3.png";